import { filterButtons } from '../utils/helpers/helper'
import { ReactComponent as ArrowUp } from '../assets/icons/arrowUp.svg'
import { useEffect, useState } from 'react'
import useCustomStore from '../hooks/useCustomStore'
import Dropdown from './Dropdown'
// import useToken from '../hooks/useToken'
import { ReactComponent as SearchIcon } from '../assets/icons/search.svg'
import { CSVLink } from 'react-csv'
import { getWalletDetails } from '../api/api'
import { TConnectionTime, TimeRange, WalletDetails, WalletDetailsResponse } from '../api/model'
import { useQuery } from 'react-query'
import moment from 'moment'
import { ReactComponent as ExternalIcon } from '../assets/icons/external.svg'
import { ReactComponent as LogoutIcon } from '../assets/icons/logout.svg'
import { logoutUser } from '../api/api'

const dateRangeOptions = [
  {
    label: 'Past 7 Days',
    value: '7d',
  },
  {
    label: 'Past 24 hours',
    value: '1d',
  },
  {
    label: 'Past 30 Days',
    value: '1m',
  },
  {
    label: 'All time',
    value: '',
  },
]

let timeout: NodeJS.Timeout

const Navbar = () => {
  const [open, setOpen] = useState<boolean>(false)
  const [dateRange, setDateRange] = useState(dateRangeOptions[3])
  const [tableData, setTableData] = useState<Record<string, string | number>[]>([])

  const { title, setFilters, selectedOption, search } = useCustomStore()

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      setFilters({ name: 'search', value: e.target.value })
    }, 700)
  }

  const handleLogout = async () => {
    await logoutUser()
    localStorage.removeItem('dynamic_authenticated_user')
    localStorage.removeItem('dynamic_authentication_token')
    localStorage.removeItem('dynamic_min_authentication_token')
    localStorage.removeItem('token')
    window.location.reload()
  }

  const { data } = useQuery<WalletDetailsResponse>(
    ['walletDetails', title.value, selectedOption, search],
    async () => {
      return await getWalletDetails({
        date: title.value as TimeRange,
        connectionTime: selectedOption as TConnectionTime,
        ...(search && { search }),
      })
    },
  )

  useEffect(() => {
    if (data) {
      const filteredData = data.rows.map((item, idx) => {
        return {
          id: idx + 1,
          createdAt: moment(item.createdAt).format('MM.DD.YYYY hh:mm A'),
          updatedAt: moment(item.updatedAt).format('MM.DD.YYYY hh:mm A'),
          walletAddress: item.address || 'N/A',
          totalNettyworth:
            item.nftUsdBalance && item.ethUsdValue
              ? Number(item.nftUsdBalance) + Number(item.ethUsdValue)
              : 'N/A',
          ethUsdValue: item.ethUsdValue ? Number(item.ethUsdValue) : 'N/A',
          nftUsdBalance: item.nftUsdBalance ? Number(item.nftUsdBalance) : 'N/A',
          username: item.user?.name ? item.user.name : 'N/A',
          email: item.user?.email ? item.user.email : 'N/A',
        }
      })
      setTableData(filteredData)
    }
  }, [data])

  // const { setToken } = useToken()
  // const handleLogout = async () => {
  //   setToken('')
  //   localStorage.removeItem('dynamic_authenticated_user')
  //   localStorage.removeItem('dynamic_authentication_token')
  //   localStorage.removeItem('dynamic_min_authentication_token')
  //   localStorage.removeItem('token')
  //   window.location.reload()
  // }
  const handleOpen = () => {
    setOpen(!open)
  }

  const tableEmailsData = tableData.map((table) => {
    return { email: table.email }
  })
  return (
    <div className='flex items-center justify-between w-full gap-2 px-[10px] py-[22px] sm:px-[29px]'>
      <div className='w-1/12'></div>
      <div className='flex w-10/12 justify-center items-center'>
        <div className='flex justify-center items-center gap-[10px]'>
          <Dropdown
            label='Date Range'
            handleOptionChange={(option) => {
              setDateRange(option as { label: string; value: string })
              setFilters(option as { name: string; value: string })
            }}
            options={dateRangeOptions}
            selected={dateRange}
          />
          <div className='relative'>
            <SearchIcon className='w-[19px] h-[18px] absolute top-1/2 left-4 -translate-y-1/2' />
            <input
              type='text'
              id='search-user'
              placeholder='Search User'
              onChange={handleSearch}
              className='w-[345px] font-inter py-4 pr-[14px] pl-12 bg-jet-black-100 border-coal-border border placeholder:text-white text-sm rounded-[2px]'
            />
          </div>

          <CSVLink
            filename='userEmails.csv'
            data={tableEmailsData}
            headers={[{ label: 'Email', key: 'email' }]}
            className='flex font-inter items-center gap-3 bg-primary-blue-400/15 py-4 px-6 text-sm font-medium rounded text-primary-blue-100'
          >
            Export <ExternalIcon className='w-[19px] h-[18px]' />
          </CSVLink>

          <div className='flex flex-col gap-2'>
            <button
              onClick={handleOpen}
              className='flex items-center gap-3 bg-[#fff] h-[60px] pl-2 w-[134px] pr-2 border-2 justify-center sm:justify-between border-input rounded placeholder:text-sm placeholder:text-[#465272] sm:pl-4 sm:pr-6 sm:w-[158px] lg:hidden'
            >
              <span className='text-sm text-[#465272]'>{title.name}</span>
              {open ? (
                <div>
                  <ArrowUp fill='#465272' className=' w-[15px] h-2' />
                </div>
              ) : (
                <div>
                  <ArrowUp fill='#465272' className='rotate-[3.142rad] w-[15px] h-2' />
                </div>
              )}
            </button>
            {open ? (
              <div className='absolute lg:hidden'>
                {filterButtons.map((item, idx) => {
                  return (
                    <ul
                      key={idx}
                      className='text-input w-[134px] sm:w-[158px] bg-light-gray-100 flex items-center text-xs sm:text-sm hover:bg-light-gray'
                    >
                      <button
                        onClick={() => {
                          setFilters(item)
                          setOpen(false)
                        }}
                        className={`pl-2 pr-2 justify-center ${
                          item.name === title.name
                            ? 'bg-primary text-white'
                            : 'bg-light-gray-100  text-light-gray'
                        } w-full hover:bg-white text-[14px] leading-6 border-r last:border-r-0 py-4 sm:px-8`}
                      >
                        {item.name}
                      </button>
                    </ul>
                  )
                })}
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className='w-1/12'>
        <button onClick={handleLogout} className='flex items-center gap-2 px-[19px] py-[14px] bg-jet-black-100 rounded-sm border-coal-border border-[1px]'>
          <span className='text-sm text-white'>Logout</span>
          <LogoutIcon className='w-[19px] h-[18px] text-primary-blue-100' />
        </button>
      </div>
    </div>
  )
}

export default Navbar
